var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_4797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45961 9.84016L7.78945 9.5126C7.89246 9.40951 7.94921 9.27235 7.94921 9.12576C7.94921 8.97926 7.89246 8.84194 7.78945 8.73885L4.05268 5.00224L7.7936 1.26131C7.89661 1.15838 7.95328 1.02107 7.95328 0.87456C7.95328 0.728055 7.89661 0.590655 7.7936 0.487646L7.46579 0.160001C7.25262 -0.0533338 6.90538 -0.0533338 6.69221 0.160001L2.22217 4.61402C2.11924 4.71695 2.04672 4.8541 2.04672 5.00191L2.04672 5.00362C2.04672 5.1502 2.11933 5.28736 2.22217 5.39029L6.6801 9.84016C6.78302 9.94325 6.92433 9.99984 7.07083 10C7.21742 10 7.35677 9.94325 7.45961 9.84016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_4797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d4095b661e969967ea0dc23d59aa97b7.svg";
export { ForwardRef as ReactComponent };